import { TransactionType } from '@shared/helpers/enums/transaction-type';
import { Mapper } from '@shared/helpers/mapper';
import {
  UpdateSecurityQuestionAnswerRequest,
  UpdateSecurityRequest,
  UpdateSecurityTaxRateRequest,
} from '../../../../web-api-client';
import { SecurityForm } from '../../abstractions/security-form';
import { EvaluationQuestion } from '../../models/evaluation-question';
import { EvaluationTaxResult } from '../../models/evaluation-tax-result';

export const mapSecurityToUpdateSecurityRequest = (
  securityId: number,
  taxResults: EvaluationTaxResult[],
  questions: EvaluationQuestion[],
  formValue: Partial<SecurityForm>,
  selectedTransactionType: TransactionType | undefined
): UpdateSecurityRequest => {
  const isGeneralRates =
    selectedTransactionType === TransactionType.GeneralRates;

  return Mapper.map(formValue, UpdateSecurityRequest, [
    {
      securityId,
      entityId: isGeneralRates ? 0 : formValue.entity?.entityId,
      clientId: isGeneralRates ? formValue.clientId : undefined,
      generalRateEntityTypeId: isGeneralRates
        ? formValue.generalRateEntityTypeId
        : undefined,
      isActive: true,
      acquisitionDate:
        !isGeneralRates && formValue.acquisitionDate
          ? formValue.acquisitionDate[0]
          : undefined,
      investmentJurisdictionId:
        formValue.investmentJurisdiction?.investmentJurisdictionId,
      name: formValue.name,
      isinCusip: isGeneralRates ? undefined : formValue.isinCusip,
      securityTypeId: formValue.securityType?.securityTypeId,
      questionAnswers: Mapper.mapByList(
        questions,
        UpdateSecurityQuestionAnswerRequest,
        [
          'name',
          'answer',
          'questionId',
          'taxPolicyId',
          'taxRuleId',
          'unsureAnswer',
          {
            isActive: true,
          },
        ]
      ),
      transactionTypeId: selectedTransactionType,
      taxRates: Mapper.mapByList(
        taxResults ?? [],
        UpdateSecurityTaxRateRequest,
        [
          'taxResultItemTypeId',
          'securityTaxResultItemId',
          'taxPolicyId',
          'taxRuleId',
          'taxResultItemId',
          'rate',
          'description',
          {
            isActive: true,
          },
        ]
      ),
    },
  ]);
};
